/** @file Length of one attachment's deform buffer in compiled form (0 for a region). */
import { assertNever } from '@pose2d/std/assertNever';
import type { AttachmentData } from '../skeletonData';

/** Numbers in the attachment's deform buffer: 2 per vertex (rigid mesh), 2 per influence (skinned mesh), 0 (region). */
export function deformSize(attachment: AttachmentData): number {
  switch (attachment.type) {
    case 'region':
      return 0;
    case 'mesh':
      return attachment.skin.kind === 'rigid' ? attachment.skin.vertices.length : attachment.skin.positions.length;
    default:
      return assertNever(attachment);
  }
}
